import React from 'react';
import { Box, Container, Stack } from '@mui/material';
import { HEADER } from '@/config';
import BoletiaFooter from '@/components/BoletiaFooter';
import BoletiaMobileFooter from '@/components/BoletiaMobileFooter';
import RecaptchaLabel from '@/components/RecaptchaLabel';
import RenderIf from '@/components/RenderIf';
import useMobile from '@/hooks/useMobile';

export default function SweepstakesLayout({
  children,
  hideRecaptcha = false,
  centerContent = false,
  fixedHeight = '',
}) {

  const { isMobile } = useMobile();
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        background: hideRecaptcha ? '#F4F5F7' : '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <RenderIf condition={centerContent}>
        <Stack
          alignItems="center"
          justifyContent="center"
          overflow="hidden"
          sx={{ minHeight: '80dvh' }}
        >
          <Stack
            gap={3}
            sx={{
              width: { xs: '100%', sm: '550px' },
              position: 'relative',
            }}
          >
            {children}
          </Stack>
        </Stack>
      </RenderIf>
      <RenderIf condition={!centerContent}>
        <Stack>
          {
            !centerContent && (
              <Box
                sx={{
                  height: HEADER.MAIN_DESKTOP_HEIGHT,
                  width: '100%',
                }}
              />
            )
          }
          <Stack
            alignItems="center"
            overflow="hidden"
          >
            <Stack
              gap={3}
              sx={{
                width: { xs: '100%', sm: '550px' },
                position: 'relative',
              }}
            >
              {children}
            </Stack>
          </Stack>
        </Stack>
      </RenderIf>
      <Box>
        <RenderIf condition={!hideRecaptcha}>
          <RecaptchaLabel />
        </RenderIf>
        <RenderIf condition={!isMobile}>
          <BoletiaFooter />
        </RenderIf>
        <RenderIf condition={isMobile}>
          <BoletiaMobileFooter />
        </RenderIf>
      </Box>
    </Box>
  );
}
